import type { BulkAddUsersJob } from '@/types/user'
import { createContext, useContext, type Dispatch, type SetStateAction } from 'react'

interface BulkAddUsersContextType {
  job: BulkAddUsersJob | null
  setJob: Dispatch<SetStateAction<BulkAddUsersJob | null>>
  organizationId: string
  setOrganizationId: Dispatch<SetStateAction<string>>
}

export const BulkAddUsersContext = createContext<BulkAddUsersContextType | null>(null)

export function useBulkAddUsersContext(): BulkAddUsersContextType {
  const context = useContext(BulkAddUsersContext)
  if (!context) {
    throw new Error('useBulkAddUsersContext must be used within a BulkAddUsersProvider')
  }
  return context
}
